<template>
    <div class="row">
        <div class="col-md-1" v-show="is_show_per_page">
            <div>
                <label>Показать по:</label>
                <select v-model="items_per_page" class="form-control">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                </select>
            </div>
        </div>
        <div class="col-md-6 pull-right">
            <nav class="pull-right" v-if="table">
                <ul class="pagination">
                    <li v-if="table.current_page && table.current_page !== 1">
                        <a
                                @click="paginate(table.current_page-1, $event)"
                                aria-label="Prev"
                        >
                            <span aria-hidden="true">&larr;</span>
                            Назад
                        </a>
                    </li>
                    <li
                            v-for="number in table.last_page"
                            :class="{active: table.current_page == number}"
                            v-if="(number - table.current_page) < 5 && (table.current_page - number) < 5"
                    >
                        <a
                                @click="paginate(number, $event)"
                                href="#"
                        >
                            {{ number }}
                        </a>
                    </li>
                    <li v-if="table.current_page !== table.last_page">
                        <a
                                @click="paginate(table.current_page+1, $event)"
                                aria-label="Next"
                        >
                            Вперед
                            <span aria-hidden="true">&rarr;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
    // component for pagination of table
    export default {
        props: ['current_route', 'display_per_page'],
        data: function () {
            return {
                table: null,
                items_per_page: 50,
                is_show_per_page: typeof this.display_per_page === 'undefined' ? true : this.display_per_page,
            };
        },
        mounted: function () {
            let saved_properties = JSON.parse(localStorage.getItem(this.current_route));

            if (saved_properties !== null && saved_properties.itemsPerPage) {
                this.itemsPerPage = saved_properties.itemsPerPage;
            }
        },
        methods: {
            paginate: function (number, event) {
                event.preventDefault();
                this.$root.$emit('update:page', number);
            }
        },
        watch: {
            'items_per_page' : function(val) {
                localStorage.setItem(this.current_route,  JSON.stringify({itemsPerPage: val}));
                this.$root.$emit('update:items_per_page', val);
            }
        },
        created: function () {
            this.$root.$on('update:table', (val) => { this.table = val});
        }
    }
</script>
